import { useCapabilities } from '@crm/hooks/useCapabilities'
import { Button, ButtonProps } from 'antd'
import { Add } from 'iconsax-react'

/**
 * Create control of a global catalog — the same primary button on every
 * catalog screen, absent for the roles that may only read them.
 */
export const CatalogAddButton = ({ children, ...props }: ButtonProps) => {
  const { canManageCatalogs } = useCapabilities()

  if (!canManageCatalogs) return null

  return (
    <Button type="primary" icon={<Add size={20} />} {...props}>
      {children}
    </Button>
  )
}
